package net.maraclinic.app.styles

import net.maraclinic.app.displayFlexColumn
import net.maraclinic.app.theme.Breakpoints
import net.maraclinic.app.theme.Dimensions
import net.maraclinic.app.theme.Theme
import org.jetbrains.compose.web.css.*

object LandingPageStyleSheet : StyleSheet() {

    val Section by style {
        displayFlexColumn()
        gap(Dimensions.ItemGap)
        alignItems(AlignItems.Center)
        maxHeight(100.vh)
        maxWidth(100.vw)
        padding(Dimensions.DefaultMainPadding)
    }

    val Text by style {
        color(Theme.LightColors.Primary)
        fontSize(Dimensions.Huge)

        media(mediaMaxWidth(Breakpoints.ExtraSmall)) {
            self style {
                fontSize(Dimensions.Medium)
            }
        }

    }

    val Logo by style {
        property("object-fit", "contain")
        overflow("hidden")
    }

}